export default 'https://tme.understood.org/assets/plant.b31aec44.glb'